import i18n from "i18next";
import { AiAssistantFeatureTypes } from "src/features/aiAssistant/types";
export const aiAssistantFeatures = [
    { id: '1', type: AiAssistantFeatureTypes.ActionPoints, active: false, get label() { return i18n.t('infos:assistant.action_points_'); } },
    { id: '2', type: AiAssistantFeatureTypes.Title, active: false, get label() { return i18n.t('infos:assistant.title_'); } },
    { id: '3', type: AiAssistantFeatureTypes.Summary, active: false, get label() { return i18n.t('infos:assistant.summary_'); } },
    { id: '4', type: AiAssistantFeatureTypes.Combined, active: true, get label() { return i18n.t('infos:assistant.combined_'); } },
];
export const activeAiAssistantFeatures = aiAssistantFeatures.filter(item => item.active);
